/**
 * JavaScript-based solution to manipulate vendor generated DOM for search.
 */
export class IllumioSearch {
    constructor() {
        if (!document.getElementById('publicElement')) {
            this.intervalCounter = 0;
            this.searchInterval = setInterval(this.searchIntervalHandler.bind(this), 100);
        }
        this.initializeTemplateSearch();
    }

    searchIntervalHandler() {
        console.debug(this);

        const searchButtons = document.getElementsByClassName('coveo-search-button');
        const magicboxIcons = document.getElementsByClassName('magic-box-icon');
        // console.debug(`» searchButtons`, searchButtons);
        // console.debug(`» magicboxIcons`, magicboxIcons);
        if (searchButtons.length>0 && magicboxIcons.length>0) {
            const searchIconClassNames = [ 'fa-solid', 'fa-magnifying-glass', 'illumio-search-icon' ];
            let counter = 0;
            for (const searchButton of searchButtons) {
                if (searchButton.childElementCount>0 && searchButton.childNodes[0].tagName==='svg') {
                    const svgElement = searchButton.removeChild(searchButton.firstChild);
                    searchButton.append(this.getIcon(searchIconClassNames));
                    const parentAnchorElement = searchButton.parentElement;
                    if (parentAnchorElement.tagName==='A' && 
                            parentAnchorElement.parentElement && 
                            parentAnchorElement.parentElement.parentElement && 
                            (parentAnchorElement.parentElement.parentElement.id==='homeSearch' || 
                                (parentAnchorElement.parentElement.parentElement.parentElement && 
                                 (parentAnchorElement.parentElement.parentElement.parentElement.id==='search' ||
                                  parentAnchorElement.parentElement.parentElement.parentElement.id==='kbSearch')))) {
                        parentAnchorElement.parentElement.append(this.getTipAnchorIcon());
                        counter++;
                    }
                }
            }

            const magicboxIconClassNames = [ 'fa-solid', 'fa-x', 'illumio-search-icon' ];
            for (const magicboxIcon of magicboxIcons) {
                if (magicboxIcon.childElementCount>0 && magicboxIcon.childNodes[0].tagName==='svg') {
                    const svgElement = magicboxIcon.removeChild(magicboxIcon.firstChild);
                    magicboxIcon.append(this.getIcon(magicboxIconClassNames));
                }
            }

            const searchButtonLoadingSvgElements = document.querySelectorAll('.coveo-search-button-loading svg');
            for (const searchButtonLoadingSvgElement of searchButtonLoadingSvgElements) {
                searchButtonLoadingSvgElement.remove();
            }

            clearInterval(this.searchInterval);
            console.debug('DOM elements for search found and processed. Cleared the interval');
        } else if (new URL(document.URL).pathname.startsWith('/shared/')) {
            clearInterval(this.searchInterval);
            console.debug('Cleared the interval for public pages.');
        } else if (this.intervalCounter>5) {
            clearInterval(this.searchInterval);
            console.debug('DOM elements for search not found!');
        }

        this.intervalCounter++;
    }

    getTipAnchorIcon() {
        const iconElement = document.createElement('i');
        iconElement.classList.add('fa-regular');
        iconElement.classList.add('fa-circle-question');
        iconElement.classList.add('illumio-search-icon');

        const anchorElement = document.createElement('a');
        anchorElement.href = '/knowledge-base/articles/Support-Portal-Search-Tips.html';
        anchorElement.classList.add('CoveoSearchButton');
        anchorElement.append(iconElement);

        const spanElement = document.createElement('span');
        spanElement.classList.add('tooltip');
        spanElement.classList.add('tooltip-bottom');
        spanElement.classList.add('tooltip-info');
        spanElement.style.pointer = 'help';
        spanElement.dataset.tip = 'Search Tip';
        spanElement.append(anchorElement);

        return spanElement;
    }

    getIcon(classNames) {
        const element = document.createElement('i');
        const classNamesForEachHandler = (className) => {
            element.classList.add(className);
        }
        classNames.forEach(classNamesForEachHandler);

        return element;
    }


    /**
     * Initialize the search box in the template.
     */
    initializeTemplateSearch() {
        this.headerSearchButton = document.getElementById('headerSearchButton');
        this.headerSearchDiv = document.getElementById('headerSearchDiv');
        // console.debug(`» this.headerSearchButton: `);
        // console.debug(this.headerSearchButton);
        // console.debug(`» this.headerSearchDiv: `);
        // console.debug(this.headerSearchDiv);

        if (this.headerSearchButton && document.location.pathname==='/search') {
            this.headerSearchButton.style.visibility = 'hidden';
        }

        if (this.headerSearchButton && this.headerSearchDiv) {
            this.headerSearchButton.dataset.formDisplayed = false;
            this.headerSearchButton.onclick = this.headerSearchButtonClickHandler.bind(this);
            document.onclick = this.headerSearchButtonClickHandler.bind(this);
            document.addEventListener('keydown', this.keydownEventEscHandler.bind(this));
        } else if (this.headerSearchButton) {
            // Hide the search button due to missing search form
            this.headerSearchButton.classList.add('hidden');
        }

        // if (this.headerSearchDiv) {
        //     const formSubmitButton = this.headerSearchDiv.querySelector('.header-search-form-button');
        //     console.debug(`» formSubmitButton: `);
        //     console.debug(formSubmitButton);
        //     if (formSubmitButton) {
        //         formSubmitButton.onclick = this.formSubmitButtonClickHandler.bind(this);
        //         console.debug(formSubmitButton.onclick);
        //     }
        // }
    }

//    formSubmitButtonClickHandler(event) {
//        console.debug(`» formSubmitButtonOnClickHandler()`);
//        console.debug(event);
//        console.debug(this);
//        if (this.headerSearchDiv) {
//            const searchForm = this.headerSearchDiv.querySelector('form');
//            if (searchForm) {
//                searchForm.submit();
//            }
//        }
//    }

    headerSearchButtonClickHandler(event) {
        // console.debug(`headerSearchButtonClickHandler(): event.currentTarget`, event.currentTarget);
        // console.debug(`headerSearchButtonClickHandler(): event.target`, event.target);
        if (event.currentTarget && event.currentTarget.nodeName==='#document' 
                && event.target.tagName==='INPUT' && event.target.ariaLabel==='Search') {
            event.target.focus();
        } else if (event.currentTarget && event.currentTarget.id=='headerSearchButton'
                && this.headerSearchDiv) {
            this.toggleHeaderSearchForm();
            event.stopPropagation();
        } else if ((event.currentTarget && event.currentTarget.id=='headerSearchDiv') ||
                   (event.target && 
                       ((event.target.classList.contains('CoveoOmnibox') && target.y<=72) ||
                        (event.target.classList.contains('magic-box-icon')) ||
                        (event.target.tagName==='svg' && event.target.classList.contains('illumio-search-icon')) || 
                        (event.target.tagName==='path' && event.target.parentElement.tagName==='svg' && event.target.parentElement.classList.contains('illumio-search-icon'))))) {
            // Do nothing
            event.stopPropagation();
        } else if (event.target.tagName==='svg' && event.target.classList.contains('header-search-form-button')) {
            if (event.target.parentElement.parentElement.tagName==='FORM') {
                event.target.parentElement.parentElement.submit();
            }
        } else if (this.headerSearchDiv) {
            this.toggleHeaderSearchForm(true);
            event.stopPropagation();
            // this.headerSearchDiv.classList.add('hidden');
        }
    }

    /**
     * Close the header search form with Esc key.
     * @param {*} event 
     */
    keydownEventEscHandler(event) {
        if (event.key==='Escape' && this.headerSearchDiv) {
            // this.headerSearchDiv.remove('hidden');
            this.toggleHeaderSearchForm(true);
        }
    }

    /**
     * Toogle header search form.
     * forceTurnOff: If true, force hiding the search form.
     */
    toggleHeaderSearchForm(forceTurnOff=false) {
        if (this.headerSearchButton && this.headerSearchDiv) {
            let isDisplayForm = true;
            if (forceTurnOff===true) {
                this.headerSearchButton.dataset.formDisplayed = false;
                isDisplayForm = false;
            } else {
                if (this.headerSearchButton.dataset.formDisplayed==='true') {
                    this.headerSearchButton.dataset.formDisplayed = !isDisplayForm;
                    isDisplayForm = !isDisplayForm;
                } else {
                    this.headerSearchButton.dataset.formDisplayed = isDisplayForm;
                }
            }

            if (isDisplayForm) {
                this.headerSearchDiv.classList.remove('hidden');
                const inputElements = this.headerSearchDiv.getElementsByTagName('input');
                if (inputElements.length>0) {
                    inputElements[0].focus();
                }
            } else {
                this.headerSearchDiv.classList.add('hidden');
            }
        }
    }
}
